var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.serverError)?_c('div',[(_vm.isUserProfile)?_c('div',{staticClass:"dashboard-layout"},[_c('Header'),_c('main',[_c('div',{staticClass:"page-content"},[_c('router-view')],1)]),_c('Footer'),_c('notifications')],1):_vm._e()]):_c('ServerErrorPage')
}
var staticRenderFns = []

export { render, staticRenderFns }